//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const slugify = require('speakingurl')

export default {
  props: ['market', 'event', 'sport', 'filter', 'competition', 'oddsVisible'],
  data() {
    return {
      loading: true,
      balance: null
    }
  },
  computed: {
    selected() {
      return _.get(this.$store.state, 'inplay.event_id') == _.get(this.event, 'id');
    },
    activeEventId() {
      return _.get(this.$store.state, 'inplay.event_id');
    },
    isEnabled() {
      if (_.get(this.event, 'status') == 'live' && _.get(this.event, 'liveodds') != 'booked') {
        return false
      }
      return true
    }
  },
  filters: {},
  mounted() {},
  methods: {
    getURL: function (event, competition) {
      if (_.get(competition, 'sport.category') == 'esport') {
        return this.localePath('/esports/match/' + event.id)
      }
      if (_.get(competition, 'sport.category') == 'virtual') {
        return this.localePath({
          name: 'virtual-slug',
          params: {
            id: event.id,
            slug: _.get(event, 'translated_sport_slug')
          },
          query: {
            event_id: event.id
          }
        })
      }

      return this.localePath({
        name: 'match-screen',
        params: {
          sport: _.get(event, 'translated_sport_slug'),
          slug: slugify(event.name) + '-' + this.getEventId(event.id),
          competition: _.get(event, 'competition_slug'),
        }
      })

      //return this.localePath('/markets?event_id=' + event.id)
    },
    openStats() {
      this.$modal.show('modal-stats')
      return
    }
  }
}
